import axios from "axios";
import {CostCenter} from "@/model/CostCenter";

const PATH = "/v2/cost-centers";

interface CostCentersResponse {
    costCenters: CostCenter[];
}

class CostCenterService {

    /**
     * Returns all cost centers, ordered by their number.
     */
    getCostCenters(): Promise<CostCenter[]> {
        return axios.get<CostCentersResponse>(PATH)
            .then(response => response.data.costCenters);
    }
}

export default new CostCenterService();
